import { useContext } from "react";

import FetchChildrenContext from "../context/FetchChildren";

export const useFetchChildren = (path: string) => {
  const fetchChildren = useContext(FetchChildrenContext);
  return () => fetchChildren(path);
};
